/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Category
 */
export interface Category {
  /**
   *
   * @type {string}
   * @memberof Category
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Category
   */
  title: string
  /**
   *
   * @type {number}
   * @memberof Category
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof Category
   */
  updatedAt: number
  /**
   *
   * @type {string}
   * @memberof Category
   */
  parentId?: string
}

/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): value is Category {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function CategoryFromJSON(json: any): Category {
  return CategoryFromJSONTyped(json, false)
}

export function CategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Category {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    title: json['title'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
    parentId: json['parentId'] == null ? undefined : json['parentId'],
  }
}

export function CategoryToJSON(json: any): Category {
  return CategoryToJSONTyped(json, false)
}

export function CategoryToJSONTyped(
  value?: Category | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    title: value['title'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
    parentId: value['parentId'],
  }
}
